var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "nav",
        {
          staticClass:
            "w-full bg-white border-b border-gray-200 p-3 flex items-center sticky top-0 justify-between",
          attrs: { id: "sticky_nav" }
        },
        [
          _c("div", { staticClass: "flex items-center" }, [
            _c(
              "svg",
              {
                staticClass: "mr-2 fill-current text-gray-600 arrow-left",
                attrs: {
                  viewBox: "64 64 896 896",
                  focusable: "false",
                  "data-icon": "arrow-left",
                  width: "1.2em",
                  height: "1.2em",
                  fill: "currentColor",
                  "aria-hidden": "true"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 000 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z"
                  }
                })
              ]
            )
          ]),
          _c("div", { staticClass: "flex items-center" }, [
            _c(
              "svg",
              {
                staticClass: "mr-2 fill-current text-gray-600",
                attrs: {
                  viewBox: "64 64 896 896",
                  focusable: "false",
                  "data-icon": "search",
                  width: "1.2em",
                  height: "1.2em",
                  fill: "currentColor",
                  "aria-hidden": "true"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                  }
                })
              ]
            ),
            _c(
              "svg",
              {
                staticClass:
                  "mr-2 fill-current text-gray-600 transform  rotate-90 ",
                attrs: {
                  viewBox: "64 64 896 896",
                  focusable: "false",
                  "data-icon": "ellipsis",
                  width: "1.5em",
                  height: "1.5em",
                  fill: "currentColor",
                  "aria-hidden": "true"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"
                  }
                })
              ]
            )
          ])
        ]
      ),
      _c("nuxt"),
      _c("flash"),
      _c("div", { attrs: { id: "trackingCodes" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5aa3391a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aa3391a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/lp_whoapp.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5aa3391a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/lp_whoapp.vue
// module chunks = 16